import { makeStyles, Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import React from 'react';

import { colors } from '../../themes/colors';

const useStyles = makeStyles({
  availabilityHeaderText: {
    fontSize: 16,
    fontFamily: 'Avenir-Book',
    marginBottom: 10,
    fontWeight: 900,
  },
  editLink: {
    color: colors.blue6,
    fontWeight: 900,
    cursor: 'pointer',
    textDecoration: 'underline',
    margin: 5,
    flex: 1,
  },
  setAvailabilityText: {
    margin: 0,
    marginTop: 10,
    textDecoration: 'underline',
  },
  welcomeContainer: {
    margin: 30,
    maxWidth: 1300,
    border: `1px solid ${colors.gray1}`,
    borderRadius: 5,
    backgroundColor: '#FFFFFF',
    minWidth: '90%',
    minHeight: 300,
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    alignItems: 'center',
  },
  lampAndComputer: {
    flex: 0,
    width: 200,
    height: 75,
    justifySelf: 'center',
    margin: 30,
  },
  welcomeTextContainer: {
    flex: 1,
    display: 'flex',
    margin: 30,
    marginLeft: 0,
    alignItems: 'center',
    minWidth: 200,
    maxWidth: '30%',
  },
  welcomeTextHeader: {
    flex: 0,
    fontSize: 18,
    fontFamily: 'Avenir-Book',
    fontWeight: 900,
  },
  welcomeTextBody: {
    flex: 1,
    fontWeight: 100,
    marginBottom: 5,
  },
  myAvailability: {
    display: 'flex',
    height: '100%',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  leftContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 30,
    paddingRight: 30,
    borderLeft: `1px solid ${colors.gray1}`,
  },
  paragraphText: {
    marginTop: 6,
    marginBottom: 6,
    color: colors.gray8,
  },
  errorIcon: {
    fontSize: 50,
    marginRight: 15,
    color: colors.red3,
  },
});

enum AvailabilityWithNoHoursTestID {
  Container = 'AvailabilityWithNoHoursTestID.Container',
  ReviewCalendarConnectionsLink = 'AvailabilityWithNoHoursTestID.ReviewCalendarConnectionsLink',
  ManageWorkingHoursLink = 'AvailabilityWithNoHoursTestID.ManageWorkingHoursLink',
}

interface Props {
  onReviewCalendarConnectionsClick: () => void;
  onManageWorkingHoursClick: () => void;
  missingCheckForConflicts: boolean;
  firstName: string;
  loading: boolean;
}

// TODO: merge AvailabilityWithNoHours and AvailabilityWithHours to remove duplication of like 95% LOC
export const AvailabilityWithNoHours: React.FC<Props> = ({
  onManageWorkingHoursClick,
  onReviewCalendarConnectionsClick,
  missingCheckForConflicts,
  firstName,
  loading,
}) => {
  const classes = useStyles();

  const calendarSectionDescriptionText = missingCheckForConflicts
    ? 'Your calendar setup is not complete. Please select your preferred calendar for managing session bookings.'
    : 'Your calendar is connected. Clients can book sessions within 30 days. Booked sessions will appear below. Click on any session for more details.';

  const calendarSectionButtonText = missingCheckForConflicts
    ? 'Select Preferred Calendar'
    : 'Review Calendar Connections';

  return (
    <div className={classes.welcomeContainer} data-testid={AvailabilityWithNoHoursTestID.Container}>
      <img
        className={classes.lampAndComputer}
        src={require('../../assets/images/lamp-and-computer.png')}
        alt="resource-item"
      />
      <div className={classes.welcomeTextContainer}>
        {!loading && missingCheckForConflicts ? <ErrorIcon className={classes.errorIcon} /> : null}

        <div>
          <Typography className={classes.welcomeTextHeader}>Welcome back, {firstName}</Typography>
          <div className={classes.welcomeTextBody}>
            <Typography className={classes.paragraphText}>
              {calendarSectionDescriptionText}
            </Typography>
            <Typography
              className={`${classes.editLink} ${classes.setAvailabilityText}`}
              onClick={onReviewCalendarConnectionsClick}
              data-testid={AvailabilityWithNoHoursTestID.ReviewCalendarConnectionsLink}
            >
              {calendarSectionButtonText}
            </Typography>
          </div>
        </div>
      </div>
      <div className={classes.myAvailability}>
        <div className={classes.leftContainer}>
          <ErrorIcon className={classes.errorIcon} />
          <div>
            <Typography className={classes.availabilityHeaderText}>
              Working Hours (Required)
            </Typography>
            <Typography className={classes.welcomeTextBody}>
              Set working hours to ensure clients can only book during the windows specified below.
              Clients can book sessions within 30 days.
            </Typography>
            <Typography
              className={`${classes.editLink} ${classes.setAvailabilityText}`}
              onClick={onManageWorkingHoursClick}
              data-testid={AvailabilityWithNoHoursTestID.ManageWorkingHoursLink}
            >
              Manage working hours
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};
